export default "__VITE_PUBLIC_ASSET__0f6d7553__"